import PdfViewerModal from '@/Components/Common/PDF/PdfViewerModal.jsx';
import PdfViewerService from '@/Services/PDF/PdfViewerService.js';
import React, {useEffect, useState} from 'react';

/**
 * PdfViewerHost
 * Composant hôte qui écoute le service et affiche la modale de visionneuse PDF.
 * Doit être monté une seule fois au niveau de l'application (layout principal).
 */
const PdfViewerHost = () => {
    const [viewerState, setViewerState] = useState(PdfViewerService.getState());

    useEffect(() => {
        // S'abonner aux changements d'état du service
        const unsubscribe = PdfViewerService.subscribe((newState) => {
            setViewerState(newState);
        });

        // Se désabonner lors du démontage
        return unsubscribe;
    }, []);

    const handleClose = () => {
        PdfViewerService.close();
    };

    return (
        <PdfViewerModal
            open={viewerState.isOpen}
            onClose={handleClose}
            file={viewerState.source}
            title={viewerState.title}
            subtitle={viewerState.subtitle}
            filename={viewerState.filename}
            documentKey={viewerState.documentKey}
            interactive={viewerState.interactive}
            disableNative={viewerState.disableNative}
            notice={viewerState.notice}
        />
    );
};

export default PdfViewerHost;
